// Keys for the "extended" definition reads (v3 template joined with its
// still-v1 data-source settings). They live here — not in the hook files —
// so the v3 registries can depend on them without importing the hooks, which
// would close a module cycle through the `@query` barrel (fatal under
// jest.mock's requireActual re-entry).
export const QUERY_EXTENDED_REQUIREMENT_DEFINITION =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITION";
export const QUERY_EXTENDED_REQUIREMENT_DEFINITIONS =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITIONS";
